import { render, staticRenderFns } from "./ScreenLaudoPerfilBiofisicoFetal.vue?vue&type=template&id=c6b6bf10&lang=true&"
import script from "./ScreenLaudoPerfilBiofisicoFetal.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoPerfilBiofisicoFetal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports